/* eslint-disable react/no-did-update-set-state */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
/* eslint-disable operator-linebreak */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/prop-types */
/* eslint-disable no-plusplus */
/* eslint-disable react/sort-comp */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Zoom from '@material-ui/core/Zoom';
import className from 'classnames';
import moment from 'moment';
import ADGMImage from '../ADGMImage';
import styles from './adgm-date-picker-jss';
import './adgm-date-picker.css';

const oneDay = 60 * 60 * 24 * 1000;
const todayTimestamp = Date.now() - (Date.now() % oneDay) + new Date().getTimezoneOffset() * 1000 * 60;
const daysMap = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const monthMap = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const currentYear = new Date(todayTimestamp).getFullYear() + 1000;
const personMaxAge = 120;
const yearsMap = [];
for (let i = currentYear; i > new Date(todayTimestamp).getFullYear() - personMaxAge; i--) yearsMap.push(i);

class ADGMDatePicker extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    const date = this.props.date
      ? new Date(this.props.date)
      : this.props.lowerLimit
      ? new Date(this.props.lowerLimit)
      : new Date();
    const year = date.getFullYear();
    const month = date.getMonth();

    const propsDate = new Date(moment(this.props.date).format('YYYY-MM-DD'));
    const selectedDay =
      new Date(propsDate) - (new Date(propsDate) % oneDay) + new Date(propsDate).getTimezoneOffset() * 1000 * 60;

    this.state = {
      year,
      month,
      selectedDay: this.props.date && selectedDay,
      monthDetails: this.getMonthDetails(year, month),
      showMonthsList: false,
      showYearsList: false,
      showDatePicker: false,
    };
  }

  componentDidMount() {
    window.addEventListener('click', this.addBackDrop);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.addBackDrop);
  }

  componentDidUpdate(prevProps) {
    this?.myRef?.current?.scrollIntoView({ block: 'nearest', inline: 'start' });
    if (prevProps.date !== this.props.date) {
      const date = this.props.date ? new Date(this.props.date) : new Date();
      const year = date.getFullYear();
      const month = date.getMonth();
      const newDate = new Date(moment(this.props.date).format('YYYY-MM-DD'));
      const selectedDay =
        new Date(newDate) - (new Date(newDate) % oneDay) + new Date(newDate).getTimezoneOffset() * 1000 * 60;
      this.setState({
        year,
        month,
        selectedDay: this.props.date && selectedDay,
        monthDetails: this.getMonthDetails(year, month),
      });
    }
  }

  addBackDrop = e => {
    // eslint-disable-next-line react/no-find-dom-node
    if (this.state.showDatePicker && !ReactDOM.findDOMNode(this).contains(e.target)) {
      this.setState({ showMonthsList: false, showYearsList: false });
      this.showDatePicker(false);
    }
  };

  showDatePicker = (showDatePicker = true) => {
    const { disabled } = this.props;
    if (disabled) return;
    this.setState({ showDatePicker });
  };

  getDayDetails = args => {
    const date = args.index - args.firstDay;
    const day = args.index % 7;
    let prevMonth = args.month - 1;
    let prevYear = args.year;
    if (prevMonth < 0) {
      prevMonth = 11;
      prevYear--;
    }
    const prevMonthNumberOfDays = this.getNumberOfDays(prevYear, prevMonth);
    const _date = (date < 0 ? prevMonthNumberOfDays + date : date % args.numberOfDays) + 1;
    const month = date < 0 ? -1 : date >= args.numberOfDays ? 1 : 0;
    const timestamp = new Date(args.year, args.month, _date).getTime();
    return {
      date: _date,
      day,
      month,
      timestamp,
      dayString: daysMap[day],
    };
  };

  getNumberOfDays = (year, month) => 40 - new Date(year, month, 40).getDate();

  getMonthDetails = (year, month) => {
    const firstDay = new Date(year, month).getDay();
    const numberOfDays = this.getNumberOfDays(year, month);
    const monthArray = [];
    const rows = 6;
    let currentDay = null;
    let index = 0;
    const cols = 7;

    for (let row = 0; row < rows; row++) {
      for (let col = 0; col < cols; col++) {
        currentDay = this.getDayDetails({
          index,
          numberOfDays,
          firstDay,
          year,
          month,
        });
        monthArray.push(currentDay);
        index++;
      }
    }
    return monthArray;
  };

  isCurrentDay = day => day.timestamp === todayTimestamp;

  isSelectedDay = day => day.timestamp === this.state.selectedDay;

  getDateFromDateString = dateValue => {
    const dateData = dateValue.split('-').map(d => parseInt(d, 10));
    if (dateData.length < 3) return null;

    const year = dateData[0];
    const month = dateData[1];
    const date = dateData[2];
    return { year, month, date };
  };

  getMonthStr = month => monthMap[Math.max(Math.min(11, month), 0)] || 'Month';

  getDateStringFromTimestamp = timestamp => {
    const dateObject = new Date(timestamp);
    const month = dateObject.getMonth() + 1;
    const date = dateObject.getDate();
    return dateObject.getFullYear() + '-' + (month < 10 ? '0' + month : month) + '-' + (date < 10 ? '0' + date : date);
  };

  setDate = dateData => {
    const selectedDay = new Date(dateData.year, dateData.month - 1, dateData.date).getTime();
    this.setState({ selectedDay });
    if (this.props.onChange) {
      this.props.onChange(selectedDay);
    }
  };

  onDateClick = day => {
    this.setState({
      selectedDay: day.timestamp,
      showDatePicker: false,
      showMonthsList: false,
      showYearsList: false,
    });
    if (this.props.onChange) {
      this.props.onChange(day.timestamp);
    }
  };

  setYear = year => {
    const { month } = this.state;
    this.setState({
      year,
      monthDetails: this.getMonthDetails(year, month),
      showYearsList: false,
    });
  };

  setMonth = month => {
    const { year } = this.state;
    this.setState({
      month,
      monthDetails: this.getMonthDetails(year, month),
      showMonthsList: false,
    });
  };

  isDayDisabled = day => {
    const { lowerLimit, upperLimit } = this.props;
    // The day is not exist in the current month
    if (day.month !== 0) return true;
    // if (new Date(day.timestamp) < new Date()) return true;

    // The day is before the lower limit
    if (lowerLimit && moment(new Date(day.timestamp)).isBefore(lowerLimit)) return true;

    // The day is after the upper limit
    if (upperLimit && moment(new Date(day.timestamp)).isAfter(upperLimit)) return true;

    return false;
  };

  isYearDisabled = year => {
    const { lowerLimit, upperLimit } = this.props;

    const lowerLimitYear = lowerLimit && +moment(new Date(lowerLimit)).format('YYYY');
    const upperLimitYear = upperLimit && +moment(new Date(upperLimit)).format('YYYY');

    if (lowerLimitYear && lowerLimitYear > year) return true;

    if (upperLimitYear && upperLimitYear < year) return true;

    return false;
  };

  isMonthDisabled = month => {
    const { year } = this.state;
    const { lowerLimit, upperLimit } = this.props;

    const lowerLimitYear = lowerLimit && +moment(new Date(lowerLimit)).format('YYYY');
    const upperLimitYear = upperLimit && +moment(new Date(upperLimit)).format('YYYY');

    // The lower limit month exist in the current selected year
    if (lowerLimitYear && year === lowerLimitYear) {
      const lowerLimitMonth = +moment(new Date(lowerLimit)).format('M');
      if (lowerLimitMonth - 1 > monthMap.findIndex(m => m === month)) return true;
    }

    // The upper limit month exist in the current selected year
    if (upperLimitYear && year === upperLimitYear) {
      const upperLimitMonth = +moment(new Date(upperLimit)).format('M');
      if (upperLimitMonth - 1 < monthMap.findIndex(m => m === month)) return true;
    }

    return false;
  };

  /**
   *  Renderers
   */

  renderCalendar() {
    const days = this.state.monthDetails.map((day, index) => (
      <div
        className={
          'c-day-container' +
          (this.isDayDisabled(day) ? ' disabled' : '') +
          (this.isCurrentDay(day) ? ' highlight' : '') +
          (this.isSelectedDay(day) ? ' highlight-green' : '')
        }
        key={index}
      >
        <div className='cdc-day'>
          <span onClick={() => this.onDateClick(day)}>{day.date}</span>
        </div>
      </div>
    ));

    return (
      <div className='c-container'>
        <div className='cc-head'>
          {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((d, i) => (
            <div key={i} className='cch-name'>
              {d}
            </div>
          ))}
        </div>
        <div className='cc-body'>{days}</div>
      </div>
    );
  }

  render() {
    const { year, month, showMonthsList, showYearsList, showDatePicker } = this.state;
    const { classes, component, calendarContainerClass, calendarClass } = this.props;

    return (
      <div className='adgm-date-picker'>
        <div className={className(classes.component_container, calendarContainerClass)}>
          {React.cloneElement(component, {
            onClick: () => this.showDatePicker(!showDatePicker),
          })}
          <Zoom in={showDatePicker}>
            <div className={className(classes.calendar_container, calendarClass)}>
              <div className='mdpc-head'>
                <div className={classes.select_dropdown}>
                  <Button onClick={() => this.setState({ showMonthsList: !showMonthsList })}>
                    <Typography component='p'>{monthMap[month]}</Typography>
                    <ADGMImage name='DownArrow.svg' alt='down-arrow' />
                  </Button>
                  <div
                    className={className(classes.dropdown_list, classes.months_dropdown, {
                      [classes.d_none]: !showMonthsList,
                    })}
                  >
                    {monthMap.map((m, i) => (
                      <Typography
                        key={i}
                        component='p'
                        className={className({
                          [classes.selected]: monthMap[month] === m,
                          [classes.selectDisabled]: this.isMonthDisabled(m),
                        })}
                        onClick={() => !this.isMonthDisabled(m) && this.setMonth(i)}
                      >
                        {m}
                      </Typography>
                    ))}
                  </div>
                </div>
                <div className={classes.select_dropdown}>
                  <Button onClick={() => this.setState({ showYearsList: !showYearsList })}>
                    <Typography component='p'>{year}</Typography>
                    <ADGMImage name='DownArrow.svg' alt='down-arrow' />
                  </Button>
                  <div
                    className={className(classes.dropdown_list, classes.years_dropdown, {
                      [classes.d_none]: !showYearsList,
                    })}
                  >
                    {yearsMap.map((y, i) => (
                      <Typography
                        key={i}
                        component='p'
                        {...(year === y ? { ref: this.myRef } : {})}
                        className={className({
                          [classes.selected]: year === y,
                          [classes.selectDisabled]: this.isYearDisabled(y),
                        })}
                        onClick={() => !this.isYearDisabled(y) && this.setYear(y)}
                      >
                        {y}
                      </Typography>
                    ))}
                  </div>
                </div>
              </div>
              <div className='mdpc-body'>{this.renderCalendar()}</div>
            </div>
          </Zoom>
        </div>
      </div>
    );
  }
}

ADGMDatePicker.propTypes = {
  classes: PropTypes.object.isRequired,
  component: PropTypes.element.isRequired,
  onChange: PropTypes.func,
  date: PropTypes.any,
  disabled: PropTypes.bool,
};

ADGMDatePicker.defaultProps = {
  date: undefined,
  disabled: false,
  onChange: null,
  min: null,
};

export default withStyles(styles)(ADGMDatePicker);
